import Vue from "vue";
import { mapGetters } from "vuex";

import { CreditsService, ErrorLogService } from "@/services";

import { LoadingSpinner } from "@/components";

import { default as DetailsGrid } from "./Grid.vue";
import { default as DetailsHeader } from "./Header.vue";
import { default as NotFound } from "./NotFound.vue";

export default Vue.extend({
    name: "CreditDetails",
    components: {
        DetailsGrid,
        DetailsHeader,
        NotFound,
        LoadingSpinner,
    },
    props: {
        id: {
            type: [String, Number],
        },
        source: {
            type: String,
            required: true,
        },
        invoiceNumber: String,
        orderNumber: String,
        dealerCode: String
    },
    data: () => ({
        isBusy: true,
        model: null,
    }),
    computed: {
        ...mapGetters(["user", "getContentItem", "hasPermission", "activeAccountId"]),
        notFound() {
            return this.model ? false : true;
        },
    },    
    mounted() {
        if( this.id && this.source){
            this.getDetailsById();
        } else if( this.invoiceNumber && this.orderNumber && this.dealerCode && this.source){
            this.getDetailsByInvoice()
        }        
    },
    methods: {
        async getDetailsById() {
            try {
                this.model = await CreditsService.getCreditDetailById({
                    accountId: this.activeAccountId,
                    userId: this.user.UserId,
                    creditMemoId: this.id,
                    invoiceSource: this.source,
                });
            } catch (err) {
                ErrorLogService.LogException(err);
            } finally {
                this.isBusy = false;
            }
        },
        async getDetailsByInvoice(){
            try{
                this.model = await CreditsService.getCreditDetailByInvoice({
                    accountId: this.activeAccountId,
                    userId: this.user.UserId,
                    invoiceNumber: this.invoiceNumber,
                    orderNumber: this.orderNumber,
                    dealerCode: this.dealerCode,
                    invoiceSource: this.source
                })
            }catch(err){
                ErrorLogService.LogException(err)
            }finally{
                this.isBusy = false
            }
        }
    },
});
